export const isStatusOk = (status: number) => {
  return status >= 200 && status < 300;
};

const isStatusNotFound = (status: number) => {
  const isNotFound = status === 404;

  console.info(`Encountered expected 404 Not Found status.`);

  return isNotFound;
};

export const weExpect404NotFound = (status: number) => {
  return isStatusOk(status) || isStatusNotFound(status);
};
